export enum UploadFileTypes {
  csv,
  image,
}
